/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from 'types/DiplomatObject';
import {SyncMatchSpecification} from './SyncMatchSpecification';
import {enums} from 'types/enums';
import {Schedule} from 'types/Schedule';
import {EmailNotifications} from 'types/EmailNotifications';
import {ArchiveDefinition} from 'types/ArchiveDefinition';
import {PreTransactionCommand, PostTransactionCommand} from 'types/TransactionCommand';
import {ZipParameters} from 'types/ZipParameters';
import {TransactionNames} from 'types/diplomat/transaction/transactionNames';
import {Partner} from 'types/Partner';
import {CONTEXT_SEND_PARAMETER} from 'common/yup/constants';
import {SourcePartner} from 'types/partners';
import {NotificationType} from 'types/diplomat/enums/NotificationType';

const SynchronizationCore = DiplomatObject.shape({
   description: yup.string(),
   includes: yup.array().of(SyncMatchSpecification),
   excludes: yup.array().of(SyncMatchSpecification),
   includeSubfolders: yup.boolean(),
   failOnAnyError: yup.boolean(),
   removeDestinationItems: yup.boolean(),
   removeSourceItems: yup.boolean(),
   allowZeroLength: yup.boolean(),
   translateInvalidChars: yup.boolean(),
   followLinks: yup.boolean(),
   recurseOrder: yup.string().oneOf(enums.recurseOrder.keys),

   // daisyChainedCommand: yup.object({}),
   // destinationPartner: yup.object({}),
   [TransactionNames.overwriteType]: yup.string().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: yup.string().transform(function (val, origin) {
         return 'SYNCHRONIZATION';
      }),
   }),

   // Partners
   [TransactionNames.sourcePartnerId]: yup.idString(),
   [TransactionNames.sourcePartner]: SourcePartner,
   // [TransactionNames.destinationPartnerId]: yup.idString(),
   // [TransactionNames.destinationPartner]: Partner,
   [TransactionNames.destinationPartners]: yup.array().of(Partner),
   [TransactionNames.destinationPartnerIds]: yup.array().of(yup.idString()),

   [TransactionNames.schedule]: Schedule,

   [TransactionNames.warnAek]: yup.boolean(),

   [TransactionNames.notifications]: EmailNotifications.defined(),
   [TransactionNames.slackWebhookUrl]: yup.url(),
   [TransactionNames.slackNotificationType]: yup.string().oneOf(NotificationType.keys),
   [TransactionNames.teamsWebhookUrl]: yup.url(),
   [TransactionNames.teamsNotificationType]: yup.string().oneOf(NotificationType.keys),

   [TransactionNames.archive]: ArchiveDefinition,
   [TransactionNames.troubleShooting]: yup.boolean(),
   [TransactionNames.preCommand]: PreTransactionCommand,
   [TransactionNames.postCommand]: PostTransactionCommand,
   [TransactionNames.zipParameters]: ZipParameters,
   [TransactionNames.daisyChainedCommand]: yup.object({
      continueOnFailure: yup.boolean(),
      daisyChainedID: yup.idString(),
   }),
}).transform(function (value, origin) {
   if (!value.destinationPartners?.[0].keySet.encryptionKeyId) {
      value.encryptDecrypt = false;
   }

   if (!value.sourcePartner.keySet.signatureKeyId) {
      value.signAuthenticate = false;
   }

   return value;
});

const SynchronizationToSend = SynchronizationCore.clone().transform(function (
   value,
   originalValue
) {
   if (!value._slackNotify) {
      value.slackWebhookUrl = null;
   }
   if (!value._teamsNotify) {
      value.teamsWebhookUrl = null;
   }

   return value;
});

export const SynchronizationWithHelpFields = SynchronizationCore.shape({
   _slackNotify: yup.boolean(),
   _teamsNotify: yup.boolean(),
}).transform(function (value, originalValue) {
   // console.debug('SynchronizationWithHelpFields notify', value, origin);
   if (value._slackNotify === undefined) {
      value._slackNotify = !!value.slackWebhookUrl;
   }
   if (value._teamsNotify === undefined) {
      value._teamsNotify = !!value.teamsWebhookUrl;
   }

   return value;
});

export type ISynchronization = yup.InferType<typeof SynchronizationWithHelpFields>;
export type ISynchronizationWithHelpFields = yup.InferType<typeof SynchronizationWithHelpFields>;

export const Synchronization = SynchronizationCore.when(CONTEXT_SEND_PARAMETER, {
   is: true,
   then: SynchronizationToSend,
   otherwise: SynchronizationWithHelpFields,
});
